import React from "react";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Download from "../../../../../../assets/svg/icons/common/Download";
import InfoIcon16 from "../../../../../../assets/svg/icons/common/InfoIcon16";
import WarningTriangleRed16 from "../../../../../../assets/svg/icons/common/WarningTriangleRed16";
import InfoInCircle from "../../../../../../../../images/v2/InfoInCircle.png";
import BlockInCircle from "../../../../../../../../images/v2/BlockInCircle.png";
import FileInCircle from "../../../../../../../../images/v2/FileInCircle.png";
import MailInCircle from "../../../../../../../../images/v2/MailInCircle.png";
import FaxInCircle from "../../../../../../../../images/v2/FaxInCircle.png";

function Index() {
  return (
    <div>
      <div className={style.rebuttal_process}>
        <div className={style.header}>
          <h5>Rebuttal Process</h5>
          <ButtonIcon bgColor={"#4C70EF"} textColor="#FFF">
            <Download color="#FFF" />
            <span>Download Template</span>
          </ButtonIcon>
        </div>

        <p className={style.paragraph}>
          When Electronic Merchant Systems receives a chargeback, which results
          in a debit to your account.{" "}
          <strong>Do not issue a credit to the cardholder by any means.</strong>
        </p>

        <div className={style.alert_info}>
          <div className={style.alert_icon}>
            <InfoIcon16 />
          </div>
          <p className={style.alert_text}>
            Please note that a chargeback dispute reason code may contain
            additional documentation. Please contact the Chargeback Unit to
            retrieve a copy of a dispute if needed.
          </p>
        </div>

        <p className={style.paragraph}>
          If you wish to dispute a chargeback, please provide any rebuttal
          documentation that may support your position. This might include a
          legible copy of the original credit card transaction receipt, internal
          invoice, job proposal, subsequent refund that may have been processed
          or any documentation related to the transaction in question. You may
          also include a descriptive letter of events to support your position.
        </p>

        <div className={style.alert_danger}>
          <div className={style.alert_icon}>
            <WarningTriangleRed16 />
          </div>
          <p className={style.alert_text}>
            DO NOT provide full card numbers in any part of your documentation.
          </p>
        </div>

        <div className={style.alert_list}>
          <h5 className={style.heading}>
            Please keep the following key points in mind when considering any
            rebuttal:
          </h5>

          <div className={style.alert_item}>
            <img src={InfoInCircle} />
            <p className={style.paragraph}>
              If the chargeback reason is for{" "}
              <strong>“Requested trans info/receipt not rcvd”</strong> or this
              is the second time that you are being debited for this chargeback,
              you have no further recourse.
            </p>
          </div>

          <div className={style.alert_item}>
            <img src={BlockInCircle} />
            <p className={style.paragraph}>
              If the chargeback reason is{" "}
              <strong>“Duplicate Processing”</strong>, two separate credit card
              receipts must be provided.
            </p>
          </div>

          <div className={style.alert_item}>
            <img src={FileInCircle} />
            <p className={style.paragraph}>
              Be sure to always address the nature of the dispute and submit
              documentation to remedy the chargeback reason code.
            </p>
          </div>
        </div>

        <div className={style.alert_info}>
          <div className={style.alert_icon}>
            <InfoIcon16 />
          </div>
          <p className={style.alert_text}>
            When preparing and submitting your response to a chargeback dispute
            or retrieval request, please note that MasterCard has implemented a
            Chargeback Excessive Page Fee. Below are the page limits for
            MasterCard rebuttal responses. If the rebuttal exceeds the listed
            pages, MasterCard will impose a $1.00 per-page rate for all pages.
            <ul className={style.unordered_list}>
              <li>
                Chargeback – To not incur the $1.00 per-page fee, rebuttals must
                be 19 pages or less.
              </li>
              <li>
                Retrieval – To not incur the $1.00 per-page fee, rebuttals must
                be 3 pages or less.
              </li>
            </ul>
          </p>
        </div>

        <p className={style.paragraph}>
          Please return any rebuttal as soon as possible to preserve your
          chargeback rights. To allow for weekends and processing time at
          Electronic Merchant Systems, MasterCard, Visa, Discover and American
          Express, your dispute must be received no later than 20 days from the
          chargeback date indicated.
        </p>

        <div className={style.supporting_document}>
          <h5 className={style.heading}>
            Send your rebuttal and any supporting documentation:
          </h5>

          <div className={style.supporting_document_body}>
            <div className={style.supporting_document_body_left}>
              <div className={style.supporting_document_body_heading}>
                <img src={MailInCircle} />
                <h5>Mail: Electronic Merchant Systems</h5>
              </div>
              <p className={style.address}>
                Attn: Chargeback Unit, 250 W Huron Road, Suite 400, Cleveland,
                Ohio 44113Phone: (800) 726-2117 (press 6, then 2)
              </p>
            </div>

            <div className={style.supporting_document_body_right}>
              <div className={style.supporting_document_body_heading}>
                <img src={FaxInCircle} />
                <h5>Fax</h5>
              </div>
              <p className={style.address}>(216) 654-0273</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Index;
